<!--Sidebar-->
	
<div class="pmd-sidebar-brand">
	<a style="pointer-events:none ;" href="#" class="navbar-brand">
		<img src="assets/images/kanz-logo.png" class="fils-logo" alt="PayKanz" height="48">
		<img src="assets/images/kanz-icon.png" class="fils-logo-icon" alt="PayKanz" height="40">
	</a>
</div>
<div class="pmd-sidebar-scrollbar">
	<ul class="nav flex-column pmd-sidebar-nav"   role="menubar">
		<li class="nav-item" role="none" pmdTooltip="Dashboard" pmdBoundary="viewport" containerClass="pf-menu-tooltip" container="body" placement="right">
			<a class="nav-link" role="menuitem" routerLink="/dashboard" routerLinkActive='active'
				aria-label="Press enter to open the dashboard page" id="dashboardLink">
				<i class="material-icons pmd-nav-item-icon material-symbols-rounded pmd-icon-sm" aria-hidden="true">dashboard</i>
				<span class="flex-grow-1">Dashboard</span>
			</a>
		</li>
		<li class="nav-item" role="none" pmdTooltip="Customers" pmdBoundary="viewport" containerClass="pf-menu-tooltip" container="body" placement="right">
			<a class="nav-link" role="menuitem" routerLinkActive='active' routerLink="/customers/customer-list"
				aria-label="Press enter to open the the users page">
				<i class="material-icons pmd-nav-item-icon material-symbols-rounded pmd-icon-sm" aria-hidden="true">people_alt</i>
				<span class="flex-grow-1" aria-hidden="true">Customers</span>
			</a>
		</li>
		<li class="nav-item" role="none" pmdTooltip="Products" pmdBoundary="viewport" containerClass="pf-menu-tooltip" container="body" placement="right">
			<a class="nav-link" role="menuitem" routerLinkActive='active' routerLink="/products/product-list"
				aria-label="Press enter to open the the group page">
				<i class="material-icons pmd-nav-item-icon material-symbols-rounded pmd-icon-sm" aria-hidden="true">category</i>
				<span class="flex-grow-1" aria-hidden="true">Products</span>
			</a>
		</li>
		<li class="nav-item" role="none" pmdTooltip="Invoices" pmdBoundary="viewport" containerClass="pf-menu-tooltip" container="body" placement="right">
			<a class="nav-link" role="menuitem" routerLinkActive='active' routerLink="/invoice/invoice-list"
				aria-label="Press enter to open the the group page">
				<i class="material-icons pmd-nav-item-icon material-symbols-rounded pmd-svg-icon pmd-icon-sm" aria-hidden="true">
					<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
						<g id="dashboard-24px">
							<path id="Path_2248" data-name="Path 2248" d="M0,0H24V24H0Z" fill="none"/>
							<g id="noun-invoicer-2942135" transform="translate(-137.231 -50.501)">
							<path id="Path_2290" data-name="Path 2290" d="M140,298.269v5.769a2.681,2.681,0,0,0,.809,1.919,1.538,1.538,0,0,0,1.5-1.534V297.5h-1.538a.771.771,0,0,0-.769.769Z" transform="translate(0 -234.23)"/>
							<path id="Path_2291" data-name="Path 2291" d="M218.624,52.616a.774.774,0,0,0-.754-.031l-2.746,1.369-3.131-1.385h0a.754.754,0,0,0-.631,0l-3.131,1.385-2.746-1.369a.766.766,0,0,0-1.115.685V70.193a3.058,3.058,0,0,1-1.063,2.308h12.6a3.076,3.076,0,0,0,3.077-3.077V53.27a.768.768,0,0,0-.362-.654Zm-10.407,5.269h4.615a.769.769,0,1,1,0,1.538h-4.615a.769.769,0,1,1,0-1.538Zm6.154,9.231h-6.154a.769.769,0,1,1,0-1.538h6.154a.769.769,0,1,1,0,1.538Zm0-3.846h-6.154a.769.769,0,1,1,0-1.538h6.154a.769.769,0,1,1,0,1.538Z" transform="translate(-60.525)"/>
							</g>
						</g>
						</svg>
				</i>
				<span class="flex-grow-1" aria-hidden="true">Invoices</span>
			</a>
		</li>
		<li class="nav-item" role="none" pmdTooltip="Payments" pmdBoundary="viewport" containerClass="pf-menu-tooltip" container="body" placement="right">
			<a class="nav-link" role="menuitem" routerLinkActive='active' routerLink="/payments"
				aria-label="Press enter to open the the group page">
				<i class="material-icons pmd-nav-item-icon material-symbols-rounded pmd-icon-sm" aria-hidden="true">payments</i>
				<span class="flex-grow-1" aria-hidden="true">Payments</span>
			</a>
		</li>
		<li class="nav-item" role="none" pmdTooltip="Reports" pmdBoundary="viewport" containerClass="pf-menu-tooltip" container="body" placement="right">
			<a class="nav-link" role="menuitem" routerLinkActive='active' routerLink="/reports"
				aria-label="Press enter to open the the group page">
				<i class="material-icons pmd-nav-item-icon material-symbols-rounded pmd-icon-sm" aria-hidden="true">
					<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
						<g id="dashboard-24px">
							<path id="Path_2248" data-name="Path 2248" d="M0,0H24V24H0Z" fill="none"/>
							<path id="area_chart_FILL1_wght500_GRAD0_opsz48" d="M25.7,21.779l-8.716-6.831a1.815,1.815,0,0,0-1.421-.383,1.778,1.778,0,0,0-1.257.765l-3.2,4.481L7.121,16.67a2.906,2.906,0,0,0-.7-.451,2.757,2.757,0,0,0-.724-.2V10.44a.892.892,0,0,1,.314.068,1.679,1.679,0,0,1,.369.2l3.825,2.842L15.1,6.724a.935.935,0,0,1,.642-.383.868.868,0,0,1,.7.191l4.781,3.825h3.552a.889.889,0,0,1,.929.929ZM6.629,24.894a.889.889,0,0,1-.929-.929V17.926a1.7,1.7,0,0,1,.355.041,1.034,1.034,0,0,1,.383.178l5,4.016,3.8-5.273a.888.888,0,0,1,.642-.369.91.91,0,0,1,.7.2L25.7,23.855v.109a.889.889,0,0,1-.929.929Z" transform="translate(-3.7 -3.613)"/>
						</g>
						</svg>
				</i>
				<span class="flex-grow-1" aria-hidden="true">Reports</span>
			</a>
		</li>
		<li class="nav-item" role="none" pmdTooltip="Support Queries" pmdBoundary="viewport" container="body" containerClass="pf-menu-tooltip" placement="right">
			<a class="nav-link" role="menuitem" routerLinkActive='active' routerLink="/support/support-list"
				aria-label="Press enter to open the the group page">
				<i class="material-icons pmd-nav-item-icon material-symbols-rounded pmd-icon-sm" aria-hidden="true">unknown_document</i>
				<span class="flex-grow-1" aria-hidden="true">Support Queries</span>
			</a>
		</li>
	</ul>
	<div class="mt-auto pf-sidebar-support-col mb-2" (click)="showHelpPopup()" >
		<button  type="button" pmdTooltip="Help & Support" pmdBoundary="viewport" container="body" placement="right" pmdRipple pmd-btn-outline color="dark" size="xs" class="pf-sidebar-support">
			<i class="material-icons material-symbols-rounded pmd-icon-sm">contact_support</i> <span class="flex-grow-1">Help & Support</span>
		</button>
		
	</div>

	<div class="pmd-sidebar-footer">
		<div class="pmd-site-info text-md-right mb-2">
			<p class="" tabindex="0" >Copyright &copy; {{currentYear}} <strong>PayKanz</strong></p>
			<p class="d-block">All Rights Reserved</p>
		</div>
		<ul class="pmd-footer-nav pmd-footer-nav-divider mb-2 mb-lg-0">
			<li><a style="pointer-events:none ;" href="/terms-conditions" aria-label="Press enter to open terms of use page">Terms of Use</a></li>
			<li><a style="pointer-events:none ;" href="/privacy-policy" aria-label="Press enter to open privacy policy page">Privacy Policy</a></li>
		</ul>
	</div>
</div>
<div class="pf-sidebar-toggle-container">
	<button type="button" (click)="toggleSideBar()" pmdRipple pmd-btn-fab color="light" size="xs" class="sidebar-toggle-arrow mt-3">
		<i class="material-icons material-symbols-rounded pmd-icon-sm">chevron_right</i>
	</button>
</div>
